export class ApiOrganizationDescriptor {
  public id: string;
  public name: string;
  public mekhCode: string;
  public mekhCodeInternal: string;
  public primaryContact: string;
  public clerkId: string;
  public address: string;
  public site: string;
  public license: string;
  public owner: string;
  public teaorCode: string;
  public teaorDescription: string;
  public employeeCount: number;
  public trustedOrganization: boolean;
  public additionalInformation: string;
  public mustUseCompanyGateForCommunication: boolean;
  public filingSystemPartnerId: string;

  public href: string;
  public modified: Date;
  public deleted: Date;
}



// WEBPACK FOOTER //
// ./src/app/modules/organization/model/api.organization.ts